import React from 'react';
import { DebounceInput } from 'react-debounce-input';

function CrmSearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  debounceTimeout = 300,
  shortcutLabel = null,
  inputRef,
  useDebounce = true,
  onKeyPress,
  onKeyDown,
  onFocus,
  wrapperStyle,
}) {
  const inputProps = {
    type: 'search',
    className: 'team-search-input',
    placeholder,
    'aria-label': ariaLabel || placeholder,
    value,
    onChange,
    onKeyPress,
    onKeyDown,
    onFocus,
  };

  return (
    <div className="team-search-wrapper" style={wrapperStyle}>
      <svg
        className="team-search-icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
          style={{ stroke: 'var(--sl-text-quaternary, #717680)' }}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {useDebounce ? (
        <DebounceInput
          {...inputProps}
          inputRef={inputRef}
          debounceTimeout={debounceTimeout}
        />
      ) : (
        <input {...inputProps} ref={inputRef} />
      )}
      {shortcutLabel && (
        <span className="team-search-shortcut">{shortcutLabel}</span>
      )}
    </div>
  );
}

export default CrmSearchInput;
